import IconCheck from '@iconify/icons-material-symbols/check';
import IconLanguage from '@iconify/icons-material-symbols/language';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuTrigger,
} from '@radix-ui/react-dropdown-menu';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '#pie/components/icon/Icon';
import { Text } from '#pie/components/text/Text';
import { Dialog } from '../layout/dialog/Dialog';

export const LanguageSwitch = () => {
  const { i18n, t } = useTranslation();
  const [showInfoDialog, setShowInfoDialog] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('showInfoDialog') === 'true') {
      setShowInfoDialog(true);
      localStorage.removeItem('showInfoDialog');
    }
  }, []);

  const changeLanguage = (lng: string) => {
    if (lng === 'en-GB' && !localStorage.getItem('languageChanged')) {
      localStorage.setItem('languageChanged', 'true');
      localStorage.setItem('showInfoDialog', 'true');
    }
    localStorage.setItem('i18nextLng', lng);

    const path = window.location.pathname;
    if (path.startsWith('/nieuws') || path === '/') {
      location.reload();
    } else {
      i18n.changeLanguage(lng);
    }

    const productFruits = window.productFruits as any;
    if (productFruits?.services) {
      productFruits.services.destroy();
    }
  };

  const languages = [
    {
      code: 'nl-NL',
      label: 'Nederlands',
      isActive: i18n.language === 'nl-NL',
    },
    {
      code: 'en-GB',
      label: 'English',
      isActive: i18n.language === 'en-GB',
    },
  ];

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            className="flex shrink-0 cursor-pointer flex-row gap-1 items-start justify-between text-left focus:outline-hidden"
            aria-label={t('common.language_selector.aria_label')}
            type="button"
          >
            <Icon
              icon={IconLanguage}
              size={24}
              className="text-content-heading hover:text-action-primary-hover"
            />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuPortal>
          <DropdownMenuContent
            sideOffset={34}
            align="end"
            className="z-50 min-w-40 overflow-auto rounded-md border border-border-menu bg-surface-base shadow-menu"
          >
            <DropdownMenuGroup>
              {languages.map((language, idx) =>
                language.isActive ? (
                  <DropdownMenuItem asChild key={language.code}>
                    <div className="flex w-full flex-row items-center justify-between gap-6 px-4 py-3 text-left data-highlighted:outline-hidden">
                      <Text className="text-content-heading font-bold">
                        {language.label}
                      </Text>
                      <Icon
                        icon={IconCheck}
                        size={20}
                        className="text-action-primary-enabled"
                      />
                    </div>
                  </DropdownMenuItem>
                ) : (
                  <DropdownMenuItem asChild key={idx}>
                    <button
                      onClick={() => changeLanguage(language.code)}
                      aria-label={`Select ${language.label} language`}
                      className="text:sm flex w-full cursor-pointer flex-col px-4 py-3 text-left data-highlighted:bg-surface-minimal-teal data-highlighted:outline-hidden"
                      type="button"
                    >
                      <Text>{language.label}</Text>
                    </button>
                  </DropdownMenuItem>
                ),
              )}
            </DropdownMenuGroup>
          </DropdownMenuContent>
        </DropdownMenuPortal>
      </DropdownMenu>

      <Dialog
        open={showInfoDialog}
        onOpenChange={setShowInfoDialog}
        title={'You switched from language'}
      >
        Not all the content could be translated due to the presence of
        dynamically generated content from other IT-systems. This affects the
        services: tickets, ticket feedback, news and knowledge articles.
      </Dialog>
    </>
  );
};
